const productListEventTypes = {
  READ_FUNDS_INFO: 'READ_FUNDS_INFO',
  READ_ALL_FUNDS_INFO: 'READ_ALL_FUNDS_INFO',
};

module.exports = productListEventTypes;
